/* Kaynak: sections/main-cart-items.liquid eski inline <script> blogu (~1358 satir).
   Dinamik degerler (sepet kalemleri, ceviriler) header'daki kucuk bootstrap
   scriptte window.__cartItemsData / window.__cartI18n olarak veriliyor.
   Script sync (defer'siz) yukleniyor: yurutme zamani inline haliyle ayni. */
  const cartItems = window.__cartItemsData || [];
  const translations = { outOfStock: (window.__cartI18n && window.__cartI18n.outOfStock) || '' };
  function showPopup(messages) {
    const popup = document.getElementById("stock-popup");
    const popupMessage = document.getElementById("popup-message");
    const overlay = document.getElementById("stock-overlay");
    popupMessage.innerHTML = messages.map((m) => `<p>${m}</p>`).join("");
    popup.classList.remove("hidden");
    overlay.classList.remove("hidden");
  }
  document.getElementById("popup-close")?.addEventListener("click", () => {
    document.getElementById("stock-popup")?.classList.add("hidden");
    document.getElementById("stock-overlay")?.classList.add("hidden");
  });
  document.getElementById("stock-overlay")?.addEventListener("click", () => {
    document.getElementById("stock-popup")?.classList.add("hidden");
    document.getElementById("stock-overlay")?.classList.add("hidden");
  });
  const unavailableItems = [];
  cartItems.forEach((i) => { if (!i.available) unavailableItems.push(`${i.title} ${translations.outOfStock}`); });
  if (unavailableItems.length > 0) showPopup(unavailableItems);
  function ensureBubble(anchor) {
    if (!anchor) return null;
    let bubble = anchor.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble desktop-cart-count-bubble';
      anchor.appendChild(bubble);
    }
    let vis = bubble.querySelector('span[aria-hidden="true"]');
    if (!vis) { vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true'); bubble.appendChild(vis); }
    let sr = bubble.querySelector('.visually-hidden');
    if (!sr) { sr = document.createElement('span'); sr.className = 'visually-hidden'; bubble.appendChild(sr); }
    return { bubble, vis, sr };
  }
  function setCartCountStrong(count){
    const n = Math.max(0, Number(count) || 0);
    document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
      let vis = bubble.querySelector('span[aria-hidden="true"]');
      let sr  = bubble.querySelector('.visually-hidden');
      if (!vis){ vis = document.createElement('span'); vis.setAttribute('aria-hidden','true'); bubble.appendChild(vis); }
      if (!sr){ sr = document.createElement('span'); sr.className='visually-hidden'; bubble.appendChild(sr); }
      vis.textContent = String(n);
      sr.textContent  = `${n} items`;
      if (n > 0) {
        bubble.style.display = '';
        bubble.closest('a,button')?.classList?.add('has-cart-count');
      } else {
        bubble.style.display = 'none';
        bubble.closest('a,button')?.classList?.remove('has-cart-count');
      }
    });
    ['cart-icon-bubble', 'cart-icon-bubble-x'].forEach(id=>{
      const a = document.getElementById(id);
      if (!a) return;
      const parts = ensureBubble(a);
      if (!parts) return;
      const { bubble, vis, sr } = parts;
      vis.textContent = String(n);
      sr.textContent  = `${n} items`;
      if (n > 0) { bubble.style.display = ''; a.classList.add('has-cart-count'); }
      else { bubble.style.display = 'none'; a.classList.remove('has-cart-count'); }
    });
    document.documentElement.setAttribute('data-cart-count', String(n));
    document.body.setAttribute('data-cart-count', String(n));
    window.themeCartCount = n;
  }
  async function refreshCartCount(){
    try{
      const r = await fetch('/cart.js?t='+Date.now(), { credentials:'same-origin', cache:'no-store' });
      if (!r.ok) return;
      const data = await r.json();
      setCartCountStrong(data.item_count || 0);
    }catch(e){ console.warn('cart.js read failed', e); }
  }
  window.setCartCount = setCartCountStrong;
  function updateCartItemIDs() {
    const updatedCartItems = document.querySelectorAll('.cart-item');
    updatedCartItems.forEach((item, index) => {
      const newIndex = index + 1;
      item.id = `CartItem-${newIndex}`;
      const removeButton = item.querySelector('cart-remove-button');
      if (removeButton) { removeButton.dataset.index = newIndex; removeButton.id = `Remove-${newIndex}`; }
      const quantityInput = item.querySelector('.quantity__input');
      if (quantityInput) { quantityInput.id = `Quantity-${newIndex}`; quantityInput.dataset.index = newIndex; }
    });
    if (updatedCartItems.length === 0) {
      document.getElementById('cart-page-tab-div')?.style?.setProperty('display','flex','important');
      document.getElementById('cart-tab')?.style?.setProperty('display','flex','important');
      document.getElementById('cart')?.style?.setProperty('display','none','important');
      const footer = document.getElementById('main-cart-footer');
      if (footer) footer.style?.setProperty('display','none','important');
    }
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.add-to-wishlistwer');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    try {
      const productHandle = btn.dataset.productHandle;
      const variantId = btn.dataset.variantId;
      const variantIdNum = parseInt(variantId, 10);
      let alreadyInWishlist;
      if (window._wkVariantIds) {
        alreadyInWishlist = window._wkVariantIds.has(variantIdNum);
      } else {
        const wpEl = document.querySelector('wishlist-page');
        if (wpEl?.wishlist?.items) {
          alreadyInWishlist = wpEl.wishlist.items.some(i => Number(i.variantId || i.variant_id) === variantIdNum);
        }
      }
      console.log('[MtF] variantId:', variantIdNum, 'cache:', window._wkVariantIds ? [...window._wkVariantIds] : null, 'alreadyInWishlist:', alreadyInWishlist);
      if (alreadyInWishlist) {
        try {
          const isArabic = window.location.href.includes('/ar/');
          if (typeof window.showToast === 'function') {
            window.showToast(
              isArabic ? 'تنبيه' : 'Already in Favorites',
              isArabic ? 'هذا المنتج موجود بالفعل في قائمة المفضلات' : 'This product is already in your favorites list'
            );
          }
        } catch (toastErr) {
          console.error('Toast gösterilemedi:', toastErr);
        }
      }
      if (!alreadyInWishlist && window.WishlistKing && typeof WishlistKing.addWishlistItem === 'function') {
        await WishlistKing.addWishlistItem({ variantId, productHandle, reload: false });
      }
      // Madde 54: favorilere eklemek urunu sepetten kaldirmamali - artik
      // sadece wishlist'e ekleniyor, sepetteki satira dokunulmuyor.
      popupContainer?.classList.remove('active');
    } catch (err) {
      console.error(err);
    } finally {
      btn.dataset.busy = '0';
    }
  });
  document.addEventListener('click', function(e){
    const legacyA = e.target.closest && e.target.closest('cart-remove-button a[href]');
    if (legacyA) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  function wirePopup(el) {
    if (!el || el.dataset.wired === '1') return;
    el.dataset.wired = '1';
    const trigger = el.querySelector('.open-popup-remove');
    const cancel = el.querySelector('.button--cancel');
    trigger?.addEventListener('click', (evt) => {
      evt.preventDefault();
      document.querySelectorAll('.popup-ctr-for-remove.active').forEach(p => p.classList.remove('active'));
      el.classList.add('active');
    });
    cancel?.addEventListener('click', (evt) => {
      evt.preventDefault();
      el.classList.remove('active');
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    const cartRemoveDialog = document.getElementById('CartRemoveConfirmDialog');
    if (cartRemoveDialog) {
      document.getElementById('CartRemoveConfirmOk')?.addEventListener('click', () => {
        const pendingBtn = cartRemoveDialog._pendingRemoveBtn;
        const pendingKey =
          cartRemoveDialog._pendingKey ||
          pendingBtn?.dataset?.key ||
          pendingBtn?.closest?.('.cart-item')?.dataset?.key;
        const pendingIndex = cartRemoveDialog._pendingIndex || pendingBtn?.dataset?.index;

        let cartItemsEl = null;
        if (pendingBtn && pendingBtn.isConnected) {
          cartItemsEl = pendingBtn.closest('cart-items') || pendingBtn.closest('cart-drawer-items');
        }
        if (!cartItemsEl) {
          cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        }

        if (cartItemsEl && (pendingKey || pendingIndex)) {
          cartItemsEl.updateQuantity({ line: pendingIndex, key: pendingKey }, 0);
        }

        cartRemoveDialog._pendingRemoveBtn = null;
        cartRemoveDialog._pendingKey = null;
        cartRemoveDialog._pendingIndex = null;
        cartRemoveDialog.hide();
      });
      document.getElementById('CartRemoveConfirmCancel')?.addEventListener('click', () => {
        cartRemoveDialog._pendingRemoveBtn = null;
        cartRemoveDialog._pendingKey = null;
        cartRemoveDialog._pendingIndex = null;
        cartRemoveDialog.hide();
      });
    }

    setTimeout(() => document.body.classList.add('cart-page-loaded'), 300);
    document.querySelectorAll('.popup-ctr-for-remove').forEach(wirePopup);
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes.forEach(n => {
          if (n.nodeType !== 1) return;
          if (n.matches?.('.popup-ctr-for-remove')) wirePopup(n);
          n.querySelectorAll?.('.popup-ctr-for-remove').forEach(wirePopup);
        });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
    const bodyClassObs = new MutationObserver(() => {
      if (document.body.classList.contains('loading') && !document.querySelector('.cart-item')) {
        document.body.classList.remove('loading');
      }
    });
    bodyClassObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('.add-to-wishlistwer, .open-popup-remove, .button--cancel, #popup-close')
      .forEach(b => { if (b.tagName === 'BUTTON') b.type = 'button'; });
    refreshCartCount();

    // Guard against external cart sync scripts that replace #cart-icon-bubble content,
    // stripping the SVG icon and leaving only count spans (identifiable by the
    // 'cart-sync-count-visible' class they add to the <a> element).
    const CART_ICON_HTML = `<div style="display:flex;justify-content:center;align-items:center;"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path fill="currentColor" d="M5 21V7h3.5v-.5q0-1.458 1.021-2.479T12 3t2.479 1.021T15.5 6.5V7H19v14zm1-1h12V8h-2.5v3h-1V8h-5v3h-1V8H6zM9.5 7h5v-.5q0-1.056-.722-1.778T12 4t-1.778.722T9.5 6.5zM6 20V8z"/></svg></div>`;
    let _iconRestoring = false;
    function restoreCartIconIfMissing(a) {
      if (_iconRestoring || !a) return;
      if (a.querySelector('svg')) return;
      _iconRestoring = true;
      const injected = a.querySelector('span[aria-hidden="true"]');
      const n = injected ? (parseInt(injected.textContent) || 0) : (window.themeCartCount || 0);
      const bubble = n > 0 ? `<div class="cart-count-bubble desktop-cart-count-bubble"><span aria-hidden="true">${n}</span><span class="visually-hidden">${n} items</span></div>` : '';
      a.innerHTML = CART_ICON_HTML + '<span class="visually-hidden">' + ((window.__cartI18n && window.__cartI18n.cart) || '') + '</span>' + bubble;
      a.classList.remove('cart-sync-count-visible');
      _iconRestoring = false;
    }
    ['cart-icon-bubble', 'cart-icon-bubble-x'].forEach(id => {
      const a = document.getElementById(id);
      if (!a) return;
      new MutationObserver(() => { if (!_iconRestoring) restoreCartIconIfMissing(a); })
        .observe(a, { childList: true });
    });
  });
  (function(){
    let _refreshTimer;
    const safeRefresh = () => { clearTimeout(_refreshTimer); _refreshTimer = setTimeout(refreshCartCount, 1500); };
    const roots = [
      document.querySelector('#main-cart-items'),
      document.querySelector('form#cart'),
      document.querySelector('table.cart-items'),
      document.querySelector('tbody')
    ].filter(Boolean);
    roots.forEach(root=>{
      const mo = new MutationObserver(muts=>{
        let removed = false;
        muts.forEach(m=>{
          m.removedNodes && m.removedNodes.forEach(n=>{
            if (n.nodeType === 1 && (n.classList?.contains('cart-item') || n.querySelector?.('.cart-item'))) removed = true;
          });
        });
        if (removed) {
          if (!document.querySelector('.cart-item')) {
            revealEmptyCartUI();
          } else if (!window._cartJsUpdating) {
            safeRefresh();
          }
        }
      });
      mo.observe(root, { childList:true, subtree:true });
    });
  })();
  function isCartEmpty(){ return !document.querySelector('.cart-item'); }
  function syncCartPageAfterUpdate(itemCount) {
    const normalizedCount = Math.max(0, Number(itemCount) || 0);
    const navTabCount = document.querySelector('.cart-nav-tab__count');
    if (navTabCount) navTabCount.textContent = `(${normalizedCount})`;

    const cartRecommendations = document.querySelector('.related-yeni--cart');
    if (cartRecommendations && normalizedCount === 0) {
      cartRecommendations.classList.add('related-yeni--cart-empty-live');
      cartRecommendations.setAttribute('aria-hidden', 'true');
    }

    const shareTrigger = document.getElementById('CartShareTrigger');
    if (shareTrigger) {
      shareTrigger.hidden = normalizedCount === 0;
      shareTrigger.setAttribute('aria-hidden', normalizedCount === 0 ? 'true' : 'false');
    }

    const mobileBenefits = document.querySelector('.cart-mobile-benefits');
    if (mobileBenefits) mobileBenefits.hidden = normalizedCount === 0;

    if (normalizedCount === 0) {
      const shareOverlay = document.getElementById('CartShareOverlay');
      const shareSheet = document.getElementById('CartShareSheet');
      if (shareOverlay) shareOverlay.hidden = true;
      if (shareSheet) shareSheet.hidden = true;
      document.querySelector('cart-items')?.classList.remove('share-sheet-open');
      document.body.classList.remove('cart-share-open');
      document.body.classList.remove('cart-summary-open');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }
  }
  window.syncCartPageAfterUpdate = syncCartPageAfterUpdate;

  function showCartWarning(){
    // Don't show cart warning if wishlist tab is active
    const urlParams = new URLSearchParams(window.location.search);
    const activeTab = urlParams.get('tab');
    if (activeTab === 'wishlist') return;

    const cartTab = document.getElementById('cart-tab');
    const cartContents = document.querySelector('.cart__contents');
    const footer = document.querySelector('.cart__footer-wrapper');
    cartTab?.style?.setProperty('display','flex','important');
    cartContents?.style?.setProperty('display','none','important');
    footer?.style?.setProperty('display','none','important');
  }
  function revealEmptyCartUI(){
    // Don't reveal empty cart UI if wishlist tab is active
    const urlParams = new URLSearchParams(window.location.search);
    const activeTab = urlParams.get('tab');
    if (activeTab === 'wishlist') return;

    document.body.classList.remove('loading');
    syncCartPageAfterUpdate(0);

    const cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl) cartItemsEl.classList.add('is-empty');
    const cartFooterEl = document.getElementById('main-cart-footer');
    if (cartFooterEl) cartFooterEl.classList.add('is-empty');

    const tabs = document.getElementById('cart-page-tab-div');
    tabs?.style?.setProperty('display','flex','important');
    const titleWrapper = document.querySelector('.title-wrapper-with-link');
    titleWrapper?.style?.setProperty('display','flex','important');
    showCartWarning();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (!document.querySelector('.cart-item')) startEmptyCartGuard();
  }
  window.revealEmptyCartUI = revealEmptyCartUI;

  // Fix: infinite_scroll.js Route B adds display:none to <html>/<body> during page transitions,
  // causing a blank screen on the cart page. Remove it immediately when detected.
  (function() {
    function stripDisplayNone(el) {
      if (el && el.style && el.style.display === 'none') el.style.removeProperty('display');
    }
    const routeBObs = new MutationObserver(() => {
      stripDisplayNone(document.documentElement);
      stripDisplayNone(document.body);
    });
    routeBObs.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    routeBObs.observe(document.body, { attributes: true, attributeFilter: ['style'] });
  })();

  let _emptyGuardTimer = null;
  function startEmptyCartGuard() {
    clearInterval(_emptyGuardTimer);
    let count = 0;
    _emptyGuardTimer = setInterval(() => {
      if (document.querySelector('.cart-item')) { clearInterval(_emptyGuardTimer); return; }
      if (++count > 60) { clearInterval(_emptyGuardTimer); return; }
      const tab = document.getElementById('cart-tab');
      const tcs = tab ? getComputedStyle(tab) : null;
      const isHidden = !tab || tcs.display === 'none' || tcs.visibility === 'hidden' || parseFloat(tcs.opacity) < 0.1;
      if (isHidden) revealEmptyCartUI();
    }, 500);
  }

  function showCartContents(){
    clearInterval(_emptyGuardTimer);
    // Don't show cart contents if wishlist tab is active
    const urlParams = new URLSearchParams(window.location.search);
    const activeTab = urlParams.get('tab');
    if (activeTab === 'wishlist') return;

    const cartTab = document.getElementById('cart-tab');
    const cartContents = document.querySelector('.cart__contents');
    const footer = document.querySelector('.cart__footer-wrapper');
    cartTab?.style?.setProperty('display','none','important');
    cartContents?.style?.removeProperty('display');
    footer?.style?.removeProperty('display');
    const cartItems = document.querySelector('cart-items');
    cartItems?.classList.remove('is-empty');
  }

  // Refresh cart section from server
  async function refreshCartSection(suppressUI = false) {
    // Capture DOM state at the start — used later to detect race conditions
    const hadItemsAtStart = !!document.querySelector('.cart-item');

    try {
      // Fetch only the two cart sections via the Section Rendering API instead
      // of re-rendering the whole cart document (which also re-ran the 68KB
      // related-products-yeni section, the full header and the footer). Falls
      // back to the original full-page fetch if the section IDs aren't present.
      const itemsEl = document.getElementById('main-cart-items');
      const footerEl = document.getElementById('main-cart-footer');
      const itemsSectionId = itemsEl && itemsEl.dataset ? itemsEl.dataset.id : null;
      const footerSectionId = footerEl && footerEl.dataset ? footerEl.dataset.id : null;
      const basePath = window.location.pathname;
      const fetchOpts = { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' };

      const parser = new DOMParser();
      let doc;
      let footerInnerHTML = null;

      if (itemsSectionId) {
        const requests = [fetch(`${basePath}?section_id=${encodeURIComponent(itemsSectionId)}`, fetchOpts)];
        if (footerSectionId) {
          requests.push(fetch(`${basePath}?section_id=${encodeURIComponent(footerSectionId)}`, fetchOpts));
        }
        const responses = await Promise.all(requests);
        if (!responses[0].ok) return;
        doc = parser.parseFromString(await responses[0].text(), 'text/html');
        if (responses[1] && responses[1].ok) {
          const fdoc = parser.parseFromString(await responses[1].text(), 'text/html');
          const fWrapper = fdoc.querySelector('[id^="shopify-section-"]');
          footerInnerHTML = fWrapper ? fWrapper.innerHTML : fdoc.body.innerHTML;
        }
      } else {
        const response = await fetch(`${basePath}?_cart_refresh=${Date.now()}`, fetchOpts);
        if (!response.ok) return;
        doc = parser.parseFromString(await response.text(), 'text/html');
        const fw = doc.querySelector('.cart__footer-wrapper');
        footerInnerHTML = fw ? fw.innerHTML : null;
      }

      const newCartItemsInFetch = doc.querySelector('#main-cart-items');
      const hasItemsInFetch = !!newCartItemsInFetch?.querySelector('.cart-item');

      // Discard stale HTML only if the cart was EMPTIED during the fetch
      // (had items at start, now DOM is empty, but fetched page still shows items).
      // Do NOT discard if cart had no items at start — that's the wishlist→cart add case.
      if (hadItemsAtStart && !document.querySelector('.cart-item') && hasItemsInFetch) {
        if (!suppressUI) revealEmptyCartUI();
        return;
      }

      if (!hasItemsInFetch) {
        if (!suppressUI) revealEmptyCartUI();
        setCartCountStrong(0);
        return;
      }

      const newCartItems = newCartItemsInFetch;
      const currentCartItems = document.querySelector('#main-cart-items');

      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
        document.querySelectorAll('.popup-ctr-for-remove').forEach(wirePopup);
      }

      const currentFooterWrapper = document.querySelector('.cart__footer-wrapper');

      if (footerInnerHTML != null && currentFooterWrapper) {
        currentFooterWrapper.innerHTML = footerInnerHTML;
      } else if (footerInnerHTML != null && !currentFooterWrapper) {
        const cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.insertAdjacentHTML('afterend', `<div class="cart__footer-wrapper">${footerInnerHTML}</div>`);
      }

      await refreshCartCount();

      if (!suppressUI) {
        if (isCartEmpty()) {
          revealEmptyCartUI();
        } else {
          showCartContents();
          document.getElementById('cart-page-tab-div')?.style?.setProperty('display','none','important');
          const cartItemsElement = document.querySelector('cart-items');
          if (cartItemsElement) cartItemsElement.style.setProperty('margin-bottom','0','important');
          const footerWrapper = document.querySelector('.cart__footer-wrapper');
          const footerDiv = document.querySelector('#main-cart-footer');
          if (footerWrapper) { footerWrapper.style.removeProperty('display'); footerWrapper.style.visibility = 'visible'; }
          if (footerDiv) { footerDiv.style.removeProperty('display'); footerDiv.style.visibility = 'visible'; }
        }
      }
    } catch (error) {
      console.error('Failed to refresh cart section:', error);
    }
  }
  window.refreshCartSection = refreshCartSection;
  // Gate: wait for wishlist-page.css AND the WishlistKing custom element class
  // to both be ready before revealing the element.
  //
  // Why two gates?
  //   • CSS gate  — ensures the stylesheet is parsed so the skeleton renders with
  //     correct dimensions (no "collapse" when CSS arrives late).
  //   • customElements gate — ensures the WK class is registered so the element
  //     upgrades immediately on display:flex, with Lit rendering the skeleton as a
  //     microtask before the next browser paint.
  //   The :not(:defined){opacity:0} rule above is a CSS-level backstop that covers
  //   any remaining sub-frame gap.
  async function ensureWishlistReady(el) {
    var gates = [];
    var link = document.querySelector('link[href*="wishlist-page"]');
    if (link && !link.sheet) {
      gates.push(new Promise(function(resolve) {
        link.addEventListener('load', resolve, { once: true });
        link.addEventListener('error', resolve, { once: true });
      }));
    }
    if (el && el.tagName === 'WISHLIST-PAGE') {
      gates.push(customElements.whenDefined('wishlist-page'));
    }
    await Promise.all(gates);
  }

  async function toggleTabs(tab){
    const w1 = document.getElementById('wishlist-tab');
    const w2 = document.getElementById('wishlist');
    const wishlist = w1 || w2;
    const c1 = document.querySelector('.cptb1');
    const c2 = document.querySelector('.cptb2');
    const cartTab = document.getElementById('cart-tab');
    const cartContents = document.querySelector('.cart__contents');
    const cartFooter = document.querySelector('.cart__footer-wrapper');

    if (tab === 'wishlist') {
      // Update tab buttons
      c2?.style?.setProperty('text-decoration','underline');
      c1?.style?.setProperty('text-decoration','none');

      // Wait for CSS + custom element class; :not(:defined){opacity:0} absorbs
      // any remaining sub-frame gap between upgrade and Lit's first render.
      await ensureWishlistReady(wishlist);

      // Show wishlist, hide all cart elements
      wishlist?.style?.setProperty('display','flex','important');
      cartTab?.style?.setProperty('display','none','important');
      cartContents?.style?.setProperty('display','none','important');
      cartFooter?.style?.setProperty('display','none','important');
    } else {
      // Update tab button styles immediately
      c1?.style?.setProperty('text-decoration','underline');
      c2?.style?.setProperty('text-decoration','none');

      // Pre-load cart content while wishlist is still visible (suppressUI=true means
      // DOM gets updated but no show/hide happens yet — avoids the empty-cart flash).
      await refreshCartSection(true);

      // Atomic switch: hide wishlist, show correct cart state in one step
      wishlist?.style?.setProperty('display','none','important');

      if (isCartEmpty()) {
        showCartWarning();
      } else {
        showCartContents();
        document.getElementById('cart-page-tab-div')?.style?.setProperty('display','none','important');
        const cartItemsElement = document.querySelector('cart-items');
        if (cartItemsElement) cartItemsElement.style.setProperty('margin-bottom','0','important');
        const footerWrapper = document.querySelector('.cart__footer-wrapper');
        const footerDiv = document.querySelector('#main-cart-footer');
        if (footerWrapper) { footerWrapper.style.removeProperty('display'); footerWrapper.style.visibility = 'visible'; }
        if (footerDiv) { footerDiv.style.removeProperty('display'); footerDiv.style.visibility = 'visible'; }
      }
    }
  }
  document.addEventListener('DOMContentLoaded', function(){
    const urlParams = new URLSearchParams(window.location.search);
    const wanted = urlParams.get('tab') === 'wishlist' ? 'wishlist' : 'cart';
    toggleTabs(wanted);
  });
  document.addEventListener('click', function(e){
    const a = e.target.closest('.cart-page-tab-button');
    if (!a) return;
    e.preventDefault();
    const tab = a.classList.contains('cptb2') ? 'wishlist' : 'cart';
    history.replaceState(null,'',`?tab=${tab}${tab === 'wishlist' ? '#wishlist' : '#cart'}`);
    toggleTabs(tab);
  });
  document.addEventListener('DOMContentLoaded', function () {
    const notifyButton = document.querySelector('.stock-notify-icc');
    if (notifyButton) {
      notifyButton.addEventListener('click', function (e) {
        e.preventDefault();
        const variantId = notifyButton.getAttribute('data-variant-id');
      });
    }

    // Intercept WishlistKing add to cart button clicks BEFORE the event fires
    document.addEventListener('click', function(e) {
      // Check if the clicked element is a WishlistKing add to cart button
      // Try multiple selectors to catch different button types
      const addToCartBtn = e.target.closest(
        '[data-wk-action="add-to-cart"], ' +
        '.wk-button[data-action="add-to-cart"], ' +
        'button[data-wk-add-to-cart], ' +
        'form[data-wk-form] button[type="submit"]'
      );

      // Check if we're inside wishlist-page and the button text contains "add" or "cart" but NOT "remove" or "delete"
      const inWishlistPage = e.target.closest('wishlist-page') !== null;
      const buttonText = e.target.textContent ? e.target.textContent.toLowerCase() : '';
      const isAddToCartText = buttonText &&
        (buttonText.includes('add') || buttonText.includes('cart') || buttonText.includes('أضف')) &&
        !(buttonText.includes('remove') || buttonText.includes('delete') || buttonText.includes('إزالة'));

      // Also check for submit buttons inside wishlist-page forms, but only if they're for add-to-cart
      const submitBtn = e.target.closest('button[type="submit"]');
      const isInAddToCartForm = submitBtn && inWishlistPage && isAddToCartText;

      if (addToCartBtn || isInAddToCartForm) {
        console.log('WishlistKing add to cart button clicked, suppressing remove toast');

        // Find the form
        const form = e.target.closest('form');
        if (form) {
          console.log('Form found, intercepting add to cart');

          // Prevent default form submission and WishlistKing's handler
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Get the variant ID from the form
          const variantIdInput = form.querySelector('input[name="id"]');
          const quantityInput = form.querySelector('input[name="quantity"]');

          if (variantIdInput) {
            const variantId = variantIdInput.value;
            const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

            console.log('Adding to cart:', { variantId, quantity });

            // Set flags
            window.suppressWishlistRemoveToast = true;
            window.recentCartAddition = true;

            // Add to cart using Shopify's API
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: variantId,
                quantity: quantity
              })
            })
            .then(response => response.json())
            .then(data => {
              console.log('Successfully added to cart:', data);

              // Show success toast
              const isArabic = window.location.href.includes('/ar/');
              if (typeof showToast === 'function') {
                showToast(
                  isArabic ? 'ناجح' : 'Successful',
                  isArabic ? 'تمت إضافة المنتج إلى السلة' : 'Product added to cart'
                );
              }

              // TODO: Remove from wishlist functionality will be added later
              // Keeping this commented out for now to avoid any issues with cart remove button

              // Trigger cart update events — cart:updated listener handles the tab switch
              window._switchToCartAfterUpdate = true;
              document.dispatchEvent(new CustomEvent('wk:add-to-cart', { detail: data }));
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { ...data, _source: 'wishlist-add' } }));
            })
            .catch(error => {
              console.error('Failed to add to cart:', error);
              alert('Failed to add product to cart. Please try again.');
            })
            .finally(() => {
              setTimeout(() => {
                window.suppressWishlistRemoveToast = false;
                window.recentCartAddition = false;
              }, 1000);
            });

            return false;
          }
        }

        // Set flag immediately when button is clicked
        window.suppressWishlistRemoveToast = true;
        // Reset after 2 seconds as a fallback
        setTimeout(() => {
          console.log('Resetting suppressWishlistRemoveToast flag');
          window.suppressWishlistRemoveToast = false;
        }, 2000);
      }
    }, true); // Use capture phase to run before WishlistKing's handlers

    // Intercept "Add wishlist to cart" button (bulk add all wishlist items)
    if (!window.wishlistBulkAddListenerAdded) {
      window.wishlistBulkAddListenerAdded = true;

      document.addEventListener('click', async function(e) {
        // ONLY match the bulk add button - must be inside wishlist-add-to-cart component
        const wishlistAddToCartComponent = e.target.closest('wishlist-add-to-cart');

        // Don't proceed if not inside the bulk add component
        if (!wishlistAddToCartComponent) {
          return;
        }

        // Now check if it's the button inside this component
        const wishlistAddToCartBtn = e.target.closest('button');

        if (wishlistAddToCartBtn && !window.addingWishlistToCart) {
          console.log('Bulk "Add wishlist to cart" button clicked - intercepting', {
            element: e.target,
            component: wishlistAddToCartComponent
          });

          // Prevent default to stop WishlistKing's handler (which seems not to work)
          e.preventDefault();
          e.stopPropagation();

          // Add loading spinner to button
          const buttonTextSpan = wishlistAddToCartBtn.querySelector('.wk-text');
          const originalButtonText = buttonTextSpan ? buttonTextSpan.innerHTML : wishlistAddToCartBtn.innerHTML;

          // Create spinner HTML
          const spinnerHTML = '<svg class="wk-bulk-add-spinner" style="animation: spin 1s linear infinite; width: 16px; height: 16px; margin-left: 8px; display: inline-block; vertical-align: middle;" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" stroke-dasharray="32" stroke-dashoffset="8" stroke-linecap="round"></circle></svg>';

          // Add spinner and disable button
          if (buttonTextSpan) {
            buttonTextSpan.innerHTML = originalButtonText + spinnerHTML;
          } else {
            wishlistAddToCartBtn.innerHTML = originalButtonText + spinnerHTML;
          }
          wishlistAddToCartBtn.disabled = true;
          wishlistAddToCartBtn.style.opacity = '0.7';
          wishlistAddToCartBtn.style.cursor = 'not-allowed';

          // Set flag to suppress remove toasts
          window.suppressWishlistRemoveToast = true;
          window.addingWishlistToCart = true;

          // Find all wishlist items and add them to cart manually
          const wishlistItems = document.querySelectorAll('wishlist-page form[data-wk-form], wishlist-product-card form');
          console.log('Found wishlist items:', wishlistItems.length);

          if (wishlistItems.length === 0) {
            console.log('No wishlist items found');

            // Remove spinner and restore button
            const spinner = wishlistAddToCartBtn.querySelector('.wk-bulk-add-spinner');
            if (spinner) spinner.remove();
            if (buttonTextSpan) {
              buttonTextSpan.innerHTML = originalButtonText;
            } else {
              wishlistAddToCartBtn.innerHTML = originalButtonText;
            }
            wishlistAddToCartBtn.disabled = false;
            wishlistAddToCartBtn.style.opacity = '';
            wishlistAddToCartBtn.style.cursor = '';

            window.addingWishlistToCart = false;
            window.suppressWishlistRemoveToast = false;
            return;
          }

          // Add each item to cart
          let addedCount = 0;
          let failedCount = 0;

          for (const form of wishlistItems) {
            const variantIdInput = form.querySelector('input[name="id"]');
            const quantityInput = form.querySelector('input[name="quantity"]');

            if (!variantIdInput) {
              console.warn('No variant ID found in form:', form);
              failedCount++;
              continue;
            }

            const variantId = variantIdInput.value;
            const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
            const wishlistItemId = form.getAttribute('data-wishlist-item-id');

            console.log(`Adding to cart: variant ${variantId}, quantity ${quantity}`);

            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: quantity })
              });

              if (response.ok) {
                addedCount++;
                console.log(`Successfully added variant ${variantId}`);

                // TODO: Remove from wishlist functionality will be added later
                // Keeping this commented out for now to avoid any issues with cart remove button
              } else {
                failedCount++;
                console.warn(`Failed to add variant ${variantId}:`, await response.text());
              }
            } catch (error) {
              failedCount++;
              console.error(`Error adding variant ${variantId}:`, error);
            }

            // Small delay between additions
            await new Promise(resolve => setTimeout(resolve, 200));
          }

          console.log(`Bulk add complete: ${addedCount} added, ${failedCount} failed`);

          // Refresh cart count
          await refreshCartCount();

          // Store initial cart count for polling
          const initialCartCount = window.themeCartCount || 0;
          console.log('Final cart count:', initialCartCount);

          // If items were added, switch to cart tab
          if (addedCount > 0) {
            console.log('Items added successfully, switching to cart tab');

            // Check if wishlist is now empty
            const remainingWishlistItems = document.querySelectorAll('wishlist-page form[data-wk-form], wishlist-product-card form');
            console.log('Remaining wishlist items:', remainingWishlistItems.length);

            // If wishlist is empty, show empty state
            if (remainingWishlistItems.length === 0) {
              console.log('Wishlist is now empty');
              const wishlistPage = document.querySelector('wishlist-page');
              if (wishlistPage) {
                // Trigger WishlistKing to show empty state
                const emptyEvent = new CustomEvent('wk:wishlist-empty');
                wishlistPage.dispatchEvent(emptyEvent);
              }
            }

            // Try to refresh WishlistKing UI
            if (window.WishlistKing && typeof WishlistKing.refresh === 'function') {
              console.log('Refreshing WishlistKing UI');
              try {
                await WishlistKing.refresh();
              } catch (err) {
                console.warn('WishlistKing refresh failed:', err);
              }
            }

            setTimeout(async () => {
              history.replaceState(null,'','?tab=cart#cart');
              await toggleTabs('cart');
              window.addingWishlistToCart = false;
              window.suppressWishlistRemoveToast = false;

              // Remove spinner and restore button (will happen on cart tab, but good to clean up)
              const spinner = wishlistAddToCartBtn.querySelector('.wk-bulk-add-spinner');
              if (spinner) spinner.remove();
              if (buttonTextSpan) {
                buttonTextSpan.innerHTML = originalButtonText;
              } else {
                wishlistAddToCartBtn.innerHTML = originalButtonText;
              }
              wishlistAddToCartBtn.disabled = false;
              wishlistAddToCartBtn.style.opacity = '';
              wishlistAddToCartBtn.style.cursor = '';
            }, 500);
            return;
          }

          // If no items were added, reset flags and remove spinner
          const spinner = wishlistAddToCartBtn.querySelector('.wk-bulk-add-spinner');
          if (spinner) spinner.remove();
          if (buttonTextSpan) {
            buttonTextSpan.innerHTML = originalButtonText;
          } else {
            wishlistAddToCartBtn.innerHTML = originalButtonText;
          }
          wishlistAddToCartBtn.disabled = false;
          wishlistAddToCartBtn.style.opacity = '';
          wishlistAddToCartBtn.style.cursor = '';

          window.addingWishlistToCart = false;
          window.suppressWishlistRemoveToast = false;
          return;

          // OLD POLLING CODE (keeping as fallback, but won't be reached)
          // Wait a bit for WishlistKing to start processing
          await new Promise(resolve => setTimeout(resolve, 1000));

          // Poll for cart count changes
          let pollCount = 0;
          const pollInterval = setInterval(async () => {
            pollCount++;
            await refreshCartCount();
            const currentCartCount = window.themeCartCount || 0;

            console.log(`Poll ${pollCount}: Cart count ${initialCartCount} -> ${currentCartCount}`);

            // If cart count increased, items were added
            if (currentCartCount > initialCartCount) {
              console.log('Cart count increased! Bulk add successful, switching to cart tab');
              clearInterval(pollInterval);

              // Switch to cart tab
              setTimeout(async () => {
                history.replaceState(null,'','?tab=cart#cart');
                await toggleTabs('cart');
                window.addingWishlistToCart = false;
                window.suppressWishlistRemoveToast = false;
              }, 500);
            }

            // Stop polling after 15 attempts (7.5 seconds)
            if (pollCount >= 15) {
              console.log('Polling timeout - checking if any items were added');
              clearInterval(pollInterval);

              // Check one more time if cart count changed at all
              const finalCartCount = window.themeCartCount || 0;
              if (finalCartCount > initialCartCount) {
                console.log('Items were added, switching to cart tab');
                setTimeout(async () => {
                  history.replaceState(null,'','?tab=cart#cart');
                  await toggleTabs('cart');
                  window.addingWishlistToCart = false;
                  window.suppressWishlistRemoveToast = false;
                }, 500);
              } else {
                console.log('No items added - operation may have failed or wishlist is empty');
                window.addingWishlistToCart = false;
                window.suppressWishlistRemoveToast = false;
              }
            }
          }, 500);
        }
      }, true);
    }

    // Listen for WishlistKing add to cart events (single product add)
    if (!window.wkAddToCartListenerAdded) {
      window.wkAddToCartListenerAdded = true;

      document.addEventListener('wk:add-to-cart', async function(event) {
        console.log('WishlistKing add to cart detected', {
          isBulkAdd: window.addingWishlistToCart,
          event: event
        });

        window.suppressWishlistRemoveToast = true;

        // Tab switch is handled by cart:updated listener after refreshCartSection completes
        if (window.addingWishlistToCart) return;
      });
    }

    // Listen for general cart update events from WishlistKing
    if (!window.cartUpdatedListenerAdded) {
      window.cartUpdatedListenerAdded = true;

      function applyMiniCartUpdateImmediately(detail) {
        if (!detail || (detail._source !== 'mini-cart' && detail._source !== 'global-cart-added-sheet' && detail._source !== 'mobile-product-form' && detail._source !== 'pdp-cart-added-sheet') || !detail.changed_key) return;
        const changedKey = String(detail.changed_key);
        const changedQuantity = Math.max(0, Number(detail.changed_quantity) || 0);
        const row = Array.from(document.querySelectorAll('.cart-item[data-key]')).find(
          item => item.dataset.key === changedKey
        );

        if (row && changedQuantity === 0) {
          const group = row.closest('.cart-group');
          row.remove();
          if (group && !group.querySelector('.cart-item')) group.remove();
        } else if (row) {
          const quantityInput = row.querySelector('.quantity__input');
          if (quantityInput) {
            quantityInput.value = changedQuantity;
            quantityInput.setAttribute('value', changedQuantity);
            quantityInput.dataset.cartQuantity = String(changedQuantity);
          }
        }

        setCartCountStrong(detail.item_count || 0);
        syncCartPageAfterUpdate(detail.item_count || 0);
        if ((detail.item_count || 0) === 0) revealEmptyCartUI();
      }

      document.addEventListener('cart:updated', async function(event) {
        const allowedSources = [
          'wishlist-add',
          'related-products',
          'mini-cart',
          'global-cart-added-sheet',
          'mobile-product-form',
          'pdp-cart-added-sheet',
          'cart-added-sheet'
        ];
        if (event.detail?._source && !allowedSources.includes(event.detail._source)) return;
        applyMiniCartUpdateImmediately(event.detail);
        await refreshCartSection();

        const _currentTab = new URLSearchParams(window.location.search).get('tab');

        if (window.addingWishlistToCart && _currentTab === 'wishlist') {
          // Bulk add: switch tab after delay
          setTimeout(async () => {
            history.replaceState(null,'','?tab=cart#cart');
            await toggleTabs('cart');
            window.addingWishlistToCart = false;
            window.suppressWishlistRemoveToast = false;
          }, 800);
        } else if (window._switchToCartAfterUpdate && _currentTab === 'wishlist' && !isCartEmpty()) {
          // Single product add from wishlist: switch directly without re-fetching
          window._switchToCartAfterUpdate = false;
          window.addingWishlistToCart = false;
          history.replaceState(null,'','?tab=cart#cart');
          const _wishlist = document.getElementById('wishlist-tab') || document.getElementById('wishlist');
          _wishlist?.style?.setProperty('display','none','important');
          document.querySelector('.cptb1')?.style?.setProperty('text-decoration','underline');
          document.querySelector('.cptb2')?.style?.setProperty('text-decoration','none');
          document.getElementById('cart-page-tab-div')?.style?.setProperty('display','none','important');
          showCartContents();
          const _fw = document.querySelector('.cart__footer-wrapper');
          const _fd = document.querySelector('#main-cart-footer');
          if (_fw) { _fw.style.removeProperty('display'); _fw.style.visibility = 'visible'; }
          if (_fd) { _fd.style.removeProperty('display'); _fd.style.visibility = 'visible'; }
        } else {
          window._switchToCartAfterUpdate = false;
          window.addingWishlistToCart = false;
        }
      });
    }

    // Listen for WishlistKing bulk add complete event
    if (!window.wkBulkAddListenerAdded) {
      window.wkBulkAddListenerAdded = true;

      document.addEventListener('wk:wishlist-added-to-cart', async function(event) {
        console.log('WishlistKing bulk add to cart complete');
        window.suppressWishlistRemoveToast = true;

        // Wait for cart to update
        await new Promise(resolve => setTimeout(resolve, 800));

        // Switch to cart tab
        history.replaceState(null,'','?tab=cart#cart');
        await toggleTabs('cart');

        // Reset flag
        setTimeout(() => {
          window.suppressWishlistRemoveToast = false;
          window.addingWishlistToCart = false;
        }, 1000);
      });
    }

    document.addEventListener('change', async function(e) {
      if (e.target.matches('wishlist-page select, wishlist-page input[type="radio"]')) {
        e.stopPropagation();

        let productCard = e.target.closest('.wk-product-card, [data-wk-product-card], wishlist-product-card');
        if (!productCard) {
          productCard = e.target.closest('[class*="product"]') ||
                       e.target.closest('[class*="wk-"]') ||
                       e.target.closest('form')?.parentElement;
        }
        if (!productCard) return;

        const selectors = productCard.querySelectorAll('select[name*="option"], input[type="radio"]:checked');
        const selectedOptions = Array.from(selectors).map(s => s.value);

        const form = productCard.querySelector('form') || e.target.closest('form');
        if (!form) return;

        let productHandle = null;
        const elementsToCheck = [productCard, form, productCard.parentElement, e.target.closest('[data-product-handle]')];
        for (const el of elementsToCheck) {
          if (el && el.getAttribute('data-product-handle')) { productHandle = el.getAttribute('data-product-handle'); break; }
        }
        if (!productHandle) {
          const productLink = productCard.querySelector('a[href*="/products/"]');
          if (productLink) { const m = productLink.getAttribute('href').match(/\/products\/([^?#\/]+)/); if (m) productHandle = m[1]; }
        }
        if (!productHandle && form.action) {
          const m = form.action.match(/products\/([^?#\/]+)/); if (m) productHandle = m[1];
        }
        if (!productHandle) return;

        try {
          const pathParts = window.location.pathname.split('/');
          const localePath = (pathParts[1] && pathParts[1].length === 2) ? `/${pathParts[1]}` : '';
          const response = await fetch(`${localePath}/products/${productHandle}.js`);
          if (!response.ok) throw new Error('Failed to fetch product');

          const product = await response.json();

          const matchingVariant = product.variants.find(variant =>
            selectedOptions.every((optionValue, index) => variant[`option${index + 1}`] === optionValue)
          );

          if (matchingVariant) {
            let variantIdInput = form.querySelector('input[name="id"]');
            if (!variantIdInput) {
              variantIdInput = document.createElement('input');
              variantIdInput.type = 'hidden';
              variantIdInput.name = 'id';
              form.appendChild(variantIdInput);
            }
            variantIdInput.value = matchingVariant.id;
            form.setAttribute('data-custom-variant-updated', 'true');

            const addToCartButton = form.querySelector('button[type="submit"], button[data-wk-add-to-cart], [data-wk-action="add-to-cart"]');

            [form, addToCartButton, productCard].forEach(element => {
              if (element) {
                if (element.hasAttribute('data-variant-id')) element.setAttribute('data-variant-id', matchingVariant.id);
                if (element.hasAttribute('data-wk-variant-id')) element.setAttribute('data-wk-variant-id', matchingVariant.id);
              }
            });

            selectors.forEach((selector, index) => {
              if (selector.tagName === 'SELECT') {
                const optionValue = matchingVariant[`option${index + 1}`];
                if (optionValue) {
                  Array.from(selector.options).forEach(option => option.removeAttribute('selected'));
                  selector.value = optionValue;
                  const selectedOption = selector.options[selector.selectedIndex];
                  if (selectedOption) selectedOption.setAttribute('selected', '');
                  const wkTextElement = selector.closest('.wk-control')?.querySelector('.wk-text');
                  if (wkTextElement) wkTextElement.textContent = optionValue;
                }
              }
            });

            if (window.WishlistKing && typeof window.WishlistKing.updateItem === 'function') {
              try {
                window.WishlistKing.updateItem({ itemId: form.getAttribute('data-wishlist-item-id'), variantId: matchingVariant.id });
              } catch (_) {}
            }

            const quantityInput = form.querySelector('input[name="quantity"], input[type="number"]');
            if (quantityInput && matchingVariant.available) {
              const min = matchingVariant.quantity_rule?.min || 1;
              const step = matchingVariant.quantity_rule?.increment || 1;
              quantityInput.setAttribute('min', min);
              quantityInput.setAttribute('step', step);
              if (parseInt(quantityInput.value) < min) quantityInput.value = min;
            }

            const priceElement = productCard.querySelector('.wk-price, [data-wk-price]');
            if (priceElement && matchingVariant.price) {
              const activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
              const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: activeCurrency
              }).format(matchingVariant.price / 100);
              const currentPriceSpan = priceElement.querySelector('.wk-current-price');
              if (currentPriceSpan) {
                currentPriceSpan.textContent = formattedPrice;
              } else {
                const existingSpan = priceElement.querySelector('span');
                if (existingSpan) { existingSpan.textContent = formattedPrice; }
                else { priceElement.innerHTML = `<span class="wk-current-price">${formattedPrice}</span>`; }
              }
            }

            if (addToCartButton) {
              const isArabic = window.location.href.includes('/ar/');
              if (matchingVariant.available) {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove('disabled', 'wk-button--disabled');
                const addToCartText = isArabic ? 'أضف إلى السلة' : 'Add to Cart';
                if (addToCartButton.querySelector('.wk-button-text')) {
                  addToCartButton.querySelector('.wk-button-text').textContent = addToCartText;
                } else if (addToCartButton.querySelector('span')) {
                  addToCartButton.querySelector('span').textContent = addToCartText;
                } else {
                  const icon = addToCartButton.innerHTML.match(/<svg[\s\S]*?<\/svg>/);
                  addToCartButton.innerHTML = icon ? icon[0] + ' ' + addToCartText : addToCartText;
                }
              } else {
                addToCartButton.disabled = true;
                addToCartButton.classList.add('disabled', 'wk-button--disabled');
                const outOfStockText = isArabic ? 'نفذ من المخزون' : 'Sold Out';
                if (addToCartButton.querySelector('.wk-button-text')) {
                  addToCartButton.querySelector('.wk-button-text').textContent = outOfStockText;
                } else if (addToCartButton.querySelector('span')) {
                  addToCartButton.querySelector('span').textContent = outOfStockText;
                } else {
                  addToCartButton.textContent = outOfStockText;
                }
              }
            }

            form.dispatchEvent(new CustomEvent('wk:variant-changed', {
              detail: { variantId: matchingVariant.id, available: matchingVariant.available, productHandle },
              bubbles: true
            }));
          }
        } catch (error) {
          console.error('Wishlist variant update error:', error);
        }
      }
    }, true);
  });

  (function () {
    // Sepeti Paylaş: aç/kapat + kopyala + WhatsApp/Facebook
    var trigger = document.getElementById('CartShareTrigger');
    var overlay = document.getElementById('CartShareOverlay');
    var sheet = document.getElementById('CartShareSheet');
    var closeBtn = document.getElementById('CartShareClose');
    if (!trigger || !overlay || !sheet) return;

    var cartItemsEl = document.querySelector('cart-items');

    function updateShareCartState(cart) {
      var subtitle = sheet.querySelector('.cart-share-sheet__subtitle');
      var count = cart && cart.item_count != null ? Number(cart.item_count) : NaN;
      if (!Number.isFinite(count)) {
        count = Array.from(document.querySelectorAll('.cart-item .quantity__input')).reduce(function (total, input) {
          return total + (Number(input.value) || 0);
        }, 0);
      }
      if (!Number.isFinite(count) || count === 0) {
        count = Number(document.documentElement.getAttribute('data-cart-count'));
      }

      if (subtitle) {
        var hasCount = Number.isFinite(count) && count > 0;
        subtitle.hidden = !hasCount;
        if (hasCount) {
          var template = subtitle.dataset.countTemplate || '__COUNT__';
          subtitle.textContent = template.replace('__COUNT__', String(count));
        }
      }

      var currentLinkInput = document.getElementById('CartShareLinkInput');
      if (currentLinkInput && cart && Array.isArray(cart.items)) {
        var permalinkParts = cart.items.map(function (item) {
          return item.variant_id + ':' + item.quantity;
        });
        currentLinkInput.value = (currentLinkInput.dataset.cartBaseUrl || '') + permalinkParts.join(',');
      }
    }

    function openShareSheet() {
      // Apply the already-synchronized page count before making the sheet
      // visible, then verify count and permalink against Shopify's cart state.
      updateShareCartState(null);
      overlay.hidden = false;
      sheet.hidden = false;
      if (cartItemsEl) cartItemsEl.classList.add('share-sheet-open');
      document.body.classList.add('cart-share-open');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');

      fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart state could not be loaded');
          return response.json();
        })
        .then(updateShareCartState)
        .catch(function (error) {
          console.error('[cart-share]', error);
        });
    }

    function closeShareSheet() {
      overlay.hidden = true;
      sheet.hidden = true;
      if (cartItemsEl) cartItemsEl.classList.remove('share-sheet-open');
      document.body.classList.remove('cart-share-open');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }

    trigger.addEventListener('click', openShareSheet);
    overlay.addEventListener('click', closeShareSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeShareSheet);

    var linkInput = document.getElementById('CartShareLinkInput');
    var copyBtn = document.getElementById('CartShareCopy');
    if (copyBtn && linkInput) {
      copyBtn.addEventListener('click', async function () {
        try {
          await navigator.clipboard.writeText(linkInput.value);
          var label = copyBtn.querySelector('span');
          if (label) label.textContent = copyBtn.dataset.copiedLabel;
          setTimeout(function () {
            if (label) label.textContent = copyBtn.dataset.copyLabel;
          }, 2000);
        } catch (error) {
          console.error(error);
        }
      });
    }

    var whatsappBtn = document.getElementById('CartShareWhatsApp');
    if (whatsappBtn && linkInput) {
      whatsappBtn.addEventListener('click', function () {
        window.open('https://wa.me/?text=' + encodeURIComponent(linkInput.value), '_blank');
      });
    }

    var emailBtn = document.getElementById('CartShareEmail');
    if (emailBtn && linkInput) {
      emailBtn.addEventListener('click', function () {
        window.location.href = 'mailto:?body=' + encodeURIComponent(linkInput.value);
      });
    }

    var facebookBtn = document.getElementById('CartShareFacebook');
    if (facebookBtn && linkInput) {
      facebookBtn.addEventListener('click', function () {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(linkInput.value), '_blank');
      });
    }
  })();

  (function () {
    // Mobil "TOPLAM" bottom sheet: main-cart-footer.liquid'in kendi <script>'i
    // refreshCartSection() tarafindan .cart__footer-wrapper innerHTML replace
    // edilince calismiyor (innerHTML ile eklenen <script> tag'leri calismaz).
    // Bu yuzden document uzerinde delegation kullaniyoruz, DOM yenilense de calisir.
    function openCartSummarySheet(toggle, overlay, sheet) {
      overlay.hidden = false;
      sheet.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('cart-summary-open');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    }

    function closeCartSummarySheet(overlay, sheet) {
      overlay.hidden = true;
      sheet.hidden = true;
      var toggle = document.getElementById('CartMobileBarToggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('cart-summary-open');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }

    document.addEventListener('click', function (e) {
      var overlay = document.getElementById('CartSummarySheetOverlay');
      var sheet = document.getElementById('CartSummarySheet');
      if (!overlay || !sheet) return;

      if (e.target.closest('#CartMobileBarToggle')) {
        var toggle = e.target.closest('#CartMobileBarToggle');
        if (sheet.hidden) {
          openCartSummarySheet(toggle, overlay, sheet);
        } else {
          closeCartSummarySheet(overlay, sheet);
        }
        return;
      }

      if (e.target.closest('#CartSummarySheetOverlay') || e.target.closest('#CartSummarySheetClose') || e.target.closest('.cart-summary-sheet__close-btn')) {
        closeCartSummarySheet(overlay, sheet);
      }
    });
  })();
